import { Outlet, RouteObject } from 'react-router-dom';
import { LoadOffersPageMobile } from 'shared/modules/load-offers/LoadOffersPageMobile';
import { LoadSuggestionsPageMobile } from 'shared/modules/load-suggestions/LoadSuggestionsPageMobile';
import { OffersPage } from '../carrier/offers/offers/OffersPage';
import { PostingsPageContextProvider } from './core/postings/PostingsPageContext';
import { TermsAndConditionsPage } from './core/shipper-profile/TermsAndConditionsPage';
import { AdvancedSearchPage } from './webview/advanced-search/AdvancedSearchPage';
import { HomeScreenPage } from './webview/home/HomeScreenPage';
import { LoadSuggestionPage } from './webview/load-suggestions/LoadSuggestionPage';
import { PostingNotificationsSettingsPage } from './webview/notifications-settings/PostingNotificationsSettingsPage';
import { PostingListPageContainerPage } from './webview/posting-list/PostingListPageContainerPage';
import { CarrierRatingsScreenPage } from './webview/ratings/CarrierRatingsScreenPage';
import { RateShipperScreen } from './webview/ratings/RateShipperScreen';
import { MobileInterfaceTestPage } from './webview/test-inteface/MobileInterfaceTestPage';
import { ShipperLimitedExperienceScreen } from './webview/shipper-profile/ShipperLimitedExperienceScreen';
import { shipperProfileMobileRoutes } from './webview/shipper-profile/ShipperProfileMobileRoutes';

export const loadboardMobileRoutes: RouteObject[] = [
  {
    path: '/shipper/:guid/*',
    element: <Outlet />,
    children: shipperProfileMobileRoutes,
  },
  { path: '/shippers-experience', element: <ShipperLimitedExperienceScreen /> },
  { path: '/rate-shipper/:guid', element: <RateShipperScreen /> },
  { path: '/terms-and-conditions/:guid', element: <TermsAndConditionsPage /> },
  { path: '/ratings', element: <CarrierRatingsScreenPage /> },
  { path: '/loads', element: <PostingListPageContainerPage /> },
  { path: 'offers/:offerGUID?', element: <OffersPage /> },
  { path: '/load-offers', element: <LoadOffersPageMobile /> },
  { path: '/suggested-loads-screen', element: <LoadSuggestionsPageMobile /> },
  {
    path: '/suggested-loads',
    element: (
      <PostingsPageContextProvider>
        <LoadSuggestionPage />
      </PostingsPageContextProvider>
    ),
  },
  { path: '/filter', element: <AdvancedSearchPage /> },
  {
    path: '/settings/notifications',
    element: <PostingNotificationsSettingsPage />,
  },
  { path: '/test/mobile-methods', element: <MobileInterfaceTestPage /> },
  { path: '*', element: <HomeScreenPage /> },
];
